<template>
  	<div class="OffRampContainer">
		  This is the chapter off ramp
	</div>
</template>
<script>
export default {
  data() {
    return {
      props: ['bookprops'], 
      //item: {},
      checked: false, 
      title: 'I-m a panel' }
  },
  methods: {
    orderBook: function(x){
			alert(x);
		}
  }
};
</script>